import { FormControlLabel } from "@mui/material";
import CustomSwitch from "../CustomSwitch";

const LicensingSwitch = ({
  isOn,
  setSelectedClinicLicensing,
  propertyName,
  label,
}) => {
  return (
    <FormControlLabel
      sx={{
        marginBottom: 0.5,
        color: isOn ? "#000" : "#5B6D7A",
        "& .MuiFormControlLabel-label": { fontWeight: "600" },
      }}
      control={
        <CustomSwitch
          checked={isOn}
          onChange={(e) => {
            setSelectedClinicLicensing((prev) => {
              const safePrev = prev || {};
              return {
                ...safePrev,
                [propertyName]: e.target.checked,
              };
            });
          }}
        />
      }
      label={label}
    />
  );
};
export default LicensingSwitch;
